/** Props Interface */
interface LinearGradientProps {
	id: string;
	startColor?: string;
	endColor?: string;
	withGradientOpacity?: boolean;
}

export function LinearGradient({
	id,
	startColor,
	endColor,
	withGradientOpacity,
}: LinearGradientProps) {
	return (
		<linearGradient
			id={id}
			x1="0"
			y1="0"
			x2="0"
			y2="1"
		>
			<stop
				offset="0%"
				stopColor={startColor || "var(--color-chart-base-1)"}
				stopOpacity={withGradientOpacity ? 0.75 : 1}
			/>
			<stop
				offset="100%"
				stopColor={endColor || "var(--color-chart-base-2)"}
				stopOpacity={withGradientOpacity ? 0.5 : 0.9}
			/>
		</linearGradient>
	);
}
